import React from "react";
import "../../css/Services_New.css";
import { motion } from "framer-motion";
import { FiArrowRight, FiCheckCircle, FiBriefcase, FiUser, FiZap, FiClock } from "react-icons/fi";
import { Link } from "react-router-dom";

export const Services_New = () => {
  const serviceData = [
    {
      id: "01",
      icon: <FiUser />,
      title: "Salary Advance Loan",
      desc: "Instant access to a portion of your upcoming salary to effortlessly bridge the gap until your next payday.",
      color: "#0ea5e9", // Sky Blue
      bgGradient: "linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%)",
      amount: "Up to 50% Salary",
      time: "10 Mins",
      features: ["No Hidden Fees", "Auto Repayment", "Zero Collateral"]
    },
    {
      id: "02",
      icon: <FiBriefcase />,
      title: "Short Term Loan",
      desc: "Flexible, small-ticket credit designed to cover immediate needs with a convenient, customized short repayment cycle.",
      color: "#f43f5e", // Rose
      bgGradient: "linear-gradient(135deg, #ffe4e6 0%, #fecdd3 100%)",
      amount: "₹10k - ₹50k",
      time: "10 Mins",
      features: ["Flexible Tenure", "Low Interest", "Quick Disbursal"]
    },
    {
      id: "03",
      icon: <FiZap />,
      title: "Emergency Loan",
      desc: "Need funds urgently? Enjoy our priority processing lane to handle any unplanned medical or financial emergencies instantly.",
      color: "#10b981", // Emerald
      bgGradient: "linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)",
      amount: "Up to ₹1L",
      time: "Instant",
      features: ["Priority Access", "Paperless Verification", "Highly Trusted"]
    }
  ];

  const cardVariants = {
    hidden: { opacity: 0, y: 40, boxShadow: "0 10px 30px rgba(15, 23, 42, 0.05)" },
    visible: (i) => ({
      opacity: 1, 
      y: 0,
      transition: { duration: 0.6, delay: i * 0.15 }
    }),
    hover: { 
      y: -15, 
      boxShadow: "0 30px 60px rgba(15, 23, 42, 0.12)",
      transition: { type: "spring", stiffness: 300, damping: 20 }
    }
  };

  const iconVariants = {
    initial: { scale: 1, rotate: 0 },
    hover: { 
      scale: 1.15, 
      rotate: 5,
      transition: { type: "spring", stiffness: 300 }
    }
  };

  const buttonVariants = {
    initial: { x: -10, opacity: 0 },
    hover: { x: 0, opacity: 1, transition: { type: "spring", stiffness: 200 } }
  };

  return (
    <section className="sn_v11_wrapper">
      <div className="sn_v11_container">
        
        <div className="sn_v11_header">
          <motion.span
            className="sn_v11_badge"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            ACTOLOAN / SERVICES
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            Our Credit <span className="sn_v11_gradient_text">Offerings</span>
          </motion.h2>
          <motion.p
            className="sn_v11_desc"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            Experience lightning-fast credit solutions tailored exactly to your lifestyle and financial emergencies.
          </motion.p>
        </div>

        <div className="sn_v11_grid">
          {serviceData.map((item, index) => (
            <motion.div 
              key={item.id}
              className="sn_v11_card"
              custom={index}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-50px" }}
              variants={cardVariants}
              whileHover="hover"
            >
              {/* Card Top Animated Area */}
              <div className="sn_v11_top" style={{ background: item.bgGradient }}>
                
                {/* Abstract floating shapes */}
                <motion.div 
                  className="sn_v11_shape shape_1"
                  animate={{ rotate: 360, scale: [1, 1.2, 1] }}
                  transition={{ duration: 15, repeat: Infinity, ease: "linear" }}
                ></motion.div>
                <motion.div 
                  className="sn_v11_shape shape_2"
                  animate={{ rotate: -360, scale: [1, 1.5, 1] }}
                  transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
                ></motion.div>
              </div>

              {/* Icon moved outside of top area so it doesn't get clipped by overflow: hidden */}
              <motion.div 
                className="sn_v11_icon_box"
                style={{ color: item.color }}
                variants={iconVariants}
              >
                {item.icon}
              </motion.div>

              {/* Card Content Area */}
              <div className="sn_v11_content">
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
                
                <div className="sn_v11_stats">
                  <div className="stat_box">
                    <span>MAX LIMIT</span>
                    <strong style={{ color: item.color }}>{item.amount}</strong>
                  </div>
                  <div className="stat_divider"></div>
                  <div className="stat_box">
                    <span>DISBURSAL</span>
                    <strong>{item.time}</strong>
                  </div>
                </div>

                <ul className="sn_v11_features">
                  {item.features.map((feature, i) => (
                    <li key={i}>
                      <FiCheckCircle color={item.color} className="f_icon" /> {feature}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Hover Action Footer */}
              <Link to="/apply-now" className="sn_v11_footer" style={{ textDecoration: 'none', color: 'inherit' }}>
                <span className="footer_text">Start Application</span>
                <motion.div 
                  className="footer_btn"
                  style={{ background: item.color }}
                  variants={buttonVariants}
                >
                  <FiArrowRight />
                </motion.div>
              </Link>

            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};
